import React from "react";
import Circle from "./Circle";
import "./eachcard.css";
import { useHistory } from "react-router-dom";

const EachCard = ({ show }) => {
  const history = useHistory();

  const handleViewDetails = () => {
    if (!show?.goto) return;

    if (show.goto.startsWith("http")) {
      window.location.href = show.goto;
    } else {
      history.replace(show.goto);
    }
  };

  return (
    <div className="eachBox">
      <div className="eachBoxTop">
        <Circle image={show?.image} />
        <div className="each2" title={show?.title}>
          {show?.title}
        </div>
      </div>
      <div className="eachBoxBottom">
        <div className="cardText">{show?.description}</div>
        <button className="buttonview" onClick={handleViewDetails}>
          View details
        </button>
      </div>
    </div>
  );
};

export default EachCard;